var _path, _path2, _circle;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.736 15.771v2.291L13.161 21l-4.586-2.938L4 21M10.445 7.663 8.575 6.47 4 9.406M13.16 14.607V21M8.575 6.469v11.593M4 9.407V21",
    stroke: "#222",
    className: "stroke",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.189 6.367c0 3.084-3.47 7.04-3.47 7.04s-3.468-3.956-3.468-7.04C13.25 4.507 14.804 3 16.72 3s3.469 1.507 3.469 3.367Z",
    stroke: "#222",
    className: "stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.72,
    cy: 6.469,
    r: 0.888,
    stroke: "#222",
    className: "stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.ad82be4f.svg";
export { ForwardRef as ReactComponent };